export default {
  "www.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1748934291955-0",
        slot: "/23161678951/www_comfortweather_topanchor",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },

        // type: "ads",
        // slot: 5417976343,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },
        position: "position-08",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1748933839054-0",
        // slot: "/23161678951/www_comfortweather_floorad",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },
        type: "anchor",
        slot: "/23161678951/www_comfortweather_floorad",
        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1748933646870-0",
        slot: "/23161678951/www_comfortweather_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },

        // type: "ads",
        // slot: 2823602597,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "250px",
        // },
        position: "position-09",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1748933696102-0",
        slot: "/23161678951/www_comfortweather_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },

        // type: "ads",
        // slot: 3294375880,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "250px",
        // },
        position: "position-13",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1748933716073-0",
        slot: "/23161678951/www_comfortweather_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },

        // type: "ads",
        // slot: 4144432862,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "250px",
        // },
        position: "position-14",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1748933736168-0",
        slot: "/23161678951/www_comfortweather_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },

        // type: "ads",
        // slot: 1981294211,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "250px",
        // },
        position: "position-15",
      },
      //   {
      //     type: "adx",
      //     id: "div-gpt-ad-1748933756108-0",
      //     slot: "/23161678951/www_comfortweather_320x250_5",
      //     rect: [320, 250],
      //     style: {
      //       minWidth: "320px",
      //       minHeight: "250px",
      //     },
      //     position: "",
      //   },
      //   {
      //     type: "adx",
      //     id: "div-gpt-ad-1748933776864-0",
      //     slot: "/23161678951/www_comfortweather_320x250_6",
      //     rect: [320, 250],
      //     style: {
      //       minWidth: "320px",
      //       minHeight: "250px",
      //     },
      //     position: "",
      //   },
      //   {
      //     type: "adx",
      //     id: "div-gpt-ad-1748933798178-0",
      //     slot: "/23161678951/www_comfortweather_320x250_7",
      //     rect: [320, 250],
      //     style: {
      //       minWidth: "320px",
      //       minHeight: "250px",
      //     },
      //     position: "",
      //   },
      //   {
      //     type: "adx",
      //     id: "div-gpt-ad-1748933822234-0",
      //     slot: "/23161678951/www_comfortweather_320x250_8",
      //     rect: [320, 250],
      //     style: {
      //       minWidth: "320px",
      //       minHeight: "250px",
      //     },
      //     position: "",
      //   },
    ],
  },
};
